import { ChevronDownIcon } from '../../../assets/icons/icons';
import { cx } from '../../../utils/cx';
import styles from './DataTable.module.scss';
import React from 'react';

interface SortableThProps {
    title: string;
    active: boolean;
    dir?: 'asc' | 'desc';
    align?: 'right';
    onClick: () => void;
}

export function SortableTh({ title, active, dir = 'asc', align, onClick }: SortableThProps) {
    return (
        <th
            className={cx(
                styles.sortable,
                align === 'right' && styles.num,
                active && styles.sorted,
                active && dir === 'asc' && styles.asc,
            )}
            aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
            onClick={onClick}
        >
            <span className={styles.thIn}>
                {title}
                <ChevronDownIcon className={styles.caret} />
            </span>
        </th>
    );
}